export default __webpack_public_path__ + "static/moneybus_small-3-efade06f08c910944cbc760f8335c059.webp";